import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const ordersTabAtom = atomWithStorage<number>("ordersTab", 0);

/** Opens the add-order dialog from anywhere on the buyer dashboard. */
export const addOrderDialogAtom = atom(false);

export const addOrderSideAtom = atom<"buy" | "sell">("buy");
